import type { PaymentTerm } from '@vy/types';
import { PAYMENT_TERMS } from '@vy/types';
import { entries, raiseUnreachable } from '@vy/utils';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { VySelectField } from '../../../../../../design-system-adapters/forms';

type PaymentTermSelectProps = {
  productIndex: number;
  productType: 'fixedProducts' | 'usageProducts';
};

export const PaymentTermSelect: React.FC<PaymentTermSelectProps> = ({ productIndex, productType }) => {
  const paymentTermOptions = entries(PAYMENT_TERMS).map(([, value]) => value);

  return (
    <VySelectField<PlanInputForm, PaymentTerm>
      name={`${productType}.${productIndex}.paymentTerm`}
      label="Payment term"
      placeholder="Select payment term"
      options={paymentTermOptions}
      getOptionLabel={getPaymentTermLabel}
      disableClearable
      data-vy="plan-charge-drawer-payment-term"
    />
  );
};

function getPaymentTermLabel(paymentTerm: PaymentTerm): string {
  switch (paymentTerm) {
    case PAYMENT_TERMS.Postpayment:
      return 'Postpaid';
    case PAYMENT_TERMS.Prepayment:
      return 'Upfront';
    default:
      return raiseUnreachable(paymentTerm);
  }
}
